import { generateTrackingAttributes } from '../util/tracking.util'

export const config = {
    hero: {
        title: ['community.hero.line1', 'community.hero.line2'],
        subtitle: 'community.subhero',
    },
    facebook: {
        className: 'end-sm bottom-sm center-xs',
        isReversed: true,
        title: 'community.facebookInfoCard.title',
        text: 'community.facebookInfoCard.subtitle',
        cta: 'community.facebookInfoCard.cta',
        link: [
            {
                href: 'community.link.facebook',
                tracking: generateTrackingAttributes({
                    label: 'facebook',
                    value: 'main-cta',
                }),
            },
            {
                href: 'community.link.facebook',
                tracking: generateTrackingAttributes({
                    label: 'facebook',
                    value: 'image-cta',
                }),
            },
        ],
    },
    instagram: {
        className: 'middle-xs start-sm center-xs',
        isReversed: false,
        title: 'community.instagramInfoCard.title',
        text: 'community.instagramInfoCard.subtitle',
        cta: 'community.instagramInfoCard.cta',
        link: [
            {
                href: 'community.link.instagram',
                tracking: generateTrackingAttributes({
                    label: 'instagram',
                    value: 'main-cta',
                }),
            },
            {
                href: 'community.link.instagram',
                tracking: generateTrackingAttributes({
                    label: 'instagram',
                    value: 'image-cta',
                }),
            },
        ],
    },
}
